import { useReveal } from "../../../../hooks/useReveal";
import styles from "./Problem.module.css";

const problems = [
  {
    icon: "📄",
    title: "Too many unqualified CVs",
    body: "Recruiters spend most of their week filtering noise instead of meeting real talent.",
  },
  {
    icon: "⏱️",
    title: "Time wasted screening",
    body: "Manual interviews and skill checks drag time-to-hire to 40+ days on average.",
  },
  {
    icon: "⚠️",
    title: "Bad hires hurt",
    body: "One wrong hire can cost up to 30% of that role's first-year salary — and morale.",
  },
  {
    icon: "🔍",
    title: "Lack of insight",
    body: "Resumes show experience — not how someone thinks, performs, or fits your team.",
  },
];

function ProblemCard({ icon, title, body }) {
  const { ref, isVisible } = useReveal();
  return (
    <div
      ref={ref}
      className={`${styles.card} ${isVisible ? styles.visible : styles.hidden}`}
    >
      <div className={styles.icon}>{icon}</div>
      <h3>{title}</h3>
      <p>{body}</p>
    </div>
  );
}

export default function Problem() {
  return (
    <section className={styles.section} id="problem">
      <div className={styles.container}>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>Hiring is broken</span>
          <h2 className={styles.h2}>Why hiring on the continent is hard.</h2>
          <p className={styles.sub}>
            Most teams lose weeks chasing the wrong candidates. Here's what's
            eating your team's time.
          </p>
        </div>

        <div className={styles.grid}>
          {problems.map((p) => (
            <ProblemCard key={p.title} {...p} />
          ))}
        </div>
      </div>
    </section>
  );
}
